var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 252,
    viewBox: "0 0 252 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251 131.556C251 95.8028 235.189 63.6917 210.217 41.7833C188.308 16.8111 156.197 1 120.444 1C54.5833 1 1 54.5833 1 120.444C1 156.189 16.8056 188.294 41.7694 210.203C63.6778 235.183 95.7944 251 131.556 251C131.789 251 132.017 250.983 132.25 250.983C132.483 250.983 132.711 251 132.944 251C198.144 251 251 198.144 251 132.944C251 132.711 250.983 132.483 250.983 132.25C250.983 132.017 251 131.789 251 131.556ZM47.7444 190.919C35.9528 174.314 28.9389 154.089 28.7944 132.25C29.1694 75.275 75.2722 29.1694 132.25 28.7944C154.089 28.9389 174.317 35.9528 190.919 47.7444C209.956 66.2028 221.833 91.9944 221.833 120.444C221.833 176.35 176.35 221.833 120.444 221.833C91.9944 221.833 66.2028 209.956 47.7444 190.919ZM3.77778 120.444C3.77778 56.1139 56.1139 3.77778 120.444 3.77778C147.828 3.77778 173.017 13.2833 192.944 29.1389C174.992 18.3389 153.989 12.1111 131.556 12.1111C65.6944 12.1111 12.1111 65.6944 12.1111 131.556C12.1111 153.983 18.3361 174.981 29.1306 192.931C13.2806 173.008 3.77778 147.822 3.77778 120.444ZM131.556 234.333C103.556 234.333 78.1472 223.069 59.5972 204.847C76.7472 217.261 97.7722 224.611 120.444 224.611C177.883 224.611 224.611 177.883 224.611 120.444C224.611 97.7722 217.261 76.7472 204.847 59.5972C223.069 78.1472 234.333 103.556 234.333 131.556C234.333 188.228 188.228 234.333 131.556 234.333Z",
    fill: "url(#paint0_linear_20_267)",
    stroke: "url(#paint1_linear_20_267)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_267",
    x1: 1,
    y1: 1,
    x2: 251,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7DB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_267",
    x1: 1,
    y1: 126,
    x2: 251,
    y2: 126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7DB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon);
export default __webpack_public_path__ + "static/media/logoicon.407977ebe045bc3cf4ee2c1a30119a3a.svg";
export { ForwardRef as ReactComponent };